import * as React from 'react';
import { map, find } from 'lodash';
import { Row, Col } from 'antd';
import i18n from 'i18n-react';

import CollapseSimple from '../../../../components/collapseSimple/CollapseSimple';
import { Operation } from '../../../../const/FlightModel';

import './CancelDetail.css';

function CancelDetail(props) {
  return (
    <div className="CancelDetail">
      <Row>
        <Col span={8} className="text-left padding-left-xl padding-bottom-md">
          <span data-unit="totalPaid" className="text-dark-blue text-md text-500">
            <strong>{i18n.translate('label.totalPaid').toString()}</strong>
          </span>
        </Col>
        <Col span={16} className="text-right padding-right-xl text-dark-blue text-500">
          <span data-unit="totalPayment" data-test="totalPayment">
            {i18n.translate('label.currency')}
            {formatValue(props.totalPayment)}
          </span>
        </Col>
      </Row>
      <div className="margin-left-xl margin-right-lg">
        <Row type="flex" justify="center">
          <Col span={24} className="CancelDetail__line bg-white-three" />
        </Row>
      </div>

      <CollapseSimple
        collapsed={true}
        name="cancelFeeDetailCollapse"
        label={
          <Row>
            <Col span={24}>
              <Row>
                <Col span={8}>
                  <span className="text-red text-md text-500">
                    <strong>{i18n.translate('label.feeCancel').toString()}</strong>
                  </span>
                </Col>
                <Col
                  span={16}
                  data-test="simulationTotal"
                  className="text-right padding-right-xl text-red text-md text-500">
                  {getSimulationTotalLabel(props)}
                </Col>
              </Row>
            </Col>
          </Row>
        }>
        {renderCancelFeeDetail(props)}
      </CollapseSimple>

      <div className="padding-eight-top-16 margin-left-xl margin-right-lg">
        <Row type="flex" justify="center">
          <Col span={24} className="CancelDetail__line bg-white-three" />
        </Row>
      </div>
    </div>
  );
}

function getSimulationTotalLabel(props) {
  if (isAllNotReimbursable(props.passengerInfo)) {
    return i18n.translate('label.doubleDash').toString() + '*';
  } else {
    return (
      currencyPrefix(props.operation, 'label.currency') + formatValue(props.totalSimulate) + '*'
    );
  }
}

function isAllNotReimbursable(passengerInfo) {
  return !find(passengerInfo, value => value.isReimbursable);
}

function renderCancelFeeDetail(props) {
  return (
    <div className="padding-left-xl padding-right-xl" data-test="cancelFeeDetail">
      <Row
        className="padding-eight-top-16 padding-eight-bottom-8"
        type="flex"
        align="middle"
        justify="center">
        <Col span={8}>
          <Row>
            <Col span={24} className="padding-left-xl text-md">
              <strong>
                <span data-unit="passengerFeeHeader" data-test="passengerFeeHeader">
                  {i18n.translate('label.passengerFee').toString()}
                </span>
              </strong>
            </Col>
          </Row>
        </Col>
        <Col span={16}>
          <Row>
            <Col span={24} className="padding-right-xl text-right text-md">
              <strong>
                <span data-unit="exchangeRateHeader" data-test="exchangeRateHeader">
                  {i18n.translate('label.feeTax').toString()}
                </span>
              </strong>
            </Col>
          </Row>
        </Col>
      </Row>
      <div className="margin-left-xl margin-right-xl padding-eight-bottom-8">
        <Row type="flex" justify="center">
          <Col span={24} className="CancelDetail__line bg-white-three" />
        </Row>
      </div>
      {renderPassengersDetailWithMiniRules(props.passengerInfo)}
    </div>
  );
}

function renderPassengersDetailWithMiniRules(passengerInfo) {
  return map(passengerInfo, (value, key) => renderPassengerDetailWithMiniRules(key, value));
}

function renderPassengerDetailWithMiniRules(type, info) {
  return (
    <Row
      key={type}
      className="padding-eight-bottom-16"
      type="flex"
      align="middle"
      justify="center"
      data-test={'passengerDetailRow' + type}>
      <Col span={8}>
        <Row>
          <Col span={24} className="padding-left-xl">
            <span data-unit="qntPassengerLabel" data-test="qntPassengerLabel">
              {getQntPassengerLabel(type, info)}
            </span>
          </Col>
          <Col span={24} className="padding-left-xl">
            <span data-unit="reimbursableLabel" data-test="reimbursableLabel">
              {getReimbursableLabel(info)}
            </span>
          </Col>
        </Row>
      </Col>
      <Col span={16}>
        <Row>
          <Col span={24} className="padding-right-xl text-right text-sm">
            <span data-unit="exchangeRateLabel" data-test="exchangeRateLabel">
              {getExchangeRateLabel(info)}
            </span>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

function getQntPassengerLabel(type, info) {
  const passengerLabel =
    info.quantity === 1
      ? i18n.translate('label.passenger').toString()
      : i18n.translate('label.passengers').toString();
  const typePassengerLabel = i18n
    .translate('features.paymentDetail.' + type + (info.quantity === 1 ? '' : 'S'))
    .toString();
  return info.quantity + ' ' + passengerLabel + ' ' + typePassengerLabel;
}

function getReimbursableLabel(info) {
  const bundle =
    'features.paymentDetail.' + (info.isReimbursable ? 'REFUNDABLE' : 'NOT_REFUNDABLE');
  return i18n.translate(bundle).toString();
}

function getExchangeRateLabel(info) {
  return info.isReimbursable
    ? i18n.translate('label.currency').toString() + ' ' + formatValue(info.totalValue)
    : i18n.translate('label.doubleDash').toString();
}

function formatValue(value) {
  return Math.abs(value)
    .toFixed(2)
    .replace('.', ',')
    .replace(/(\d)(?=(\d{3})+,)/g, '$1.');
}

function currencyPrefix(operation, currencyBundle) {
  const currencyLabel = i18n.translate(currencyBundle);
  return (
    (operation === Operation.PAYMENT || operation === Operation.PAYMENT_FREE ? '- ' : '') +
    currencyLabel
  );
}

export default CancelDetail;



// WEBPACK FOOTER //
// ./src/page/flightDetailsPage/components/cancelDetail/CancelDetail.jsx